export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 34.2337b54a.jpg";